import { useState, useEffect } from 'react';

import { useGeoValue } from '@entities/geo';
import { useUserRole } from '@entities/user';

export const useRedirectUrl = () => {
  const [redirectUrl, setRedirectUrl] = useState('');

  const userRole = useUserRole();
  const geoValue = useGeoValue();

  useEffect(() => {
    if (!userRole) {
      setRedirectUrl('');
      return;
    }

    switch (userRole) {
      case 'admin':
        setRedirectUrl(`/dashboard?geo=${geoValue}`);
        break;

      case 'merchant':
        setRedirectUrl(`/dashboard?geo=${geoValue}`);
        break;

      case 'operator':
        setRedirectUrl(`/requests/deposit?geo=${geoValue}`);
        break;

      case 'provider':
        setRedirectUrl('/requests/deposit');
        break;

      default:
        setRedirectUrl('');
        break;
    }
  }, [userRole, geoValue]);

  return { redirectUrl };
};
